import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "border-b border-cyan-400/10 bg-slate-950/95 backdrop-blur-xl sticky top-0 z-40"
}
const _hoisted_2 = { class: "mx-auto max-w-7xl px-4 py-4 flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-4" }
const _hoisted_4 = { class: "text-sm uppercase tracking-[0.35em] text-cyan-300/70" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { class: "flex items-center gap-3" }
const _hoisted_11 = {
  key: 1,
  type: "button",
  disabled: "",
  "aria-disabled": "true",
  class: "cursor-not-allowed rounded-2xl px-4 py-2 text-sm font-medium text-slate-500 opacity-40"
}
const _hoisted_12 = {
  key: 3,
  type: "button",
  disabled: "",
  "aria-disabled": "true",
  class: "cursor-not-allowed rounded-2xl px-4 py-2 text-sm font-medium text-slate-500 opacity-40"
}
const _hoisted_13 = { class: "border-l border-cyan-400/10 pl-4 ml-2" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "text-sm text-slate-400" }
const _hoisted_16 = { class: "text-cyan-100 font-semibold" }

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useOrdersStore } from '../store/orders';
import { useLanguage } from '../composables/useLanguage';
import { useSessionStore } from '../store/session';

const PORTAL_OWNER_EMAIL = 'gelferclub@gmail.com';


export default /*@__PURE__*/_defineComponent({
  __name: 'TopNav',
  setup(__props) {

const route = useRoute();
const ordersStore = useOrdersStore();
const { language, setLanguage, t } = useLanguage();
const sessionStore = useSessionStore();
const hideGuestTableNav = computed(() => {
  const path = route.path || '';
  const hash = typeof window !== 'undefined' ? window.location.hash : '';
  return (
    path.startsWith('/table') ||
    hash.includes('/table') ||
    route.matched.some((record) => record.path.startsWith('/table'))
  );
});

const currentPanel = computed(() => {
  const path = route.path;
  if (path === '/') return 'portal';
  if (path.includes('/table')) return 'table';
  if (path.includes('/kitchen')) return 'kitchen';
  if (path.includes('/admin')) return 'admin';
  return 'cafe';
});

const orderCount = computed(() => ordersStore.orders.length);

const canOpenAdmin = computed(() => {
  const role = sessionStore.desktopUser?.role;
  return role !== 'kitchen' && role !== 'staff';
});

const canOpenPortalOwner = computed(() => (
  String(sessionStore.desktopUser?.email || '').trim().toLowerCase() === PORTAL_OWNER_EMAIL
));

const canOpenTable = computed(() => currentPanel.value !== 'kitchen');

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!hideGuestTableNav.value)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (currentPanel.value === 'portal')
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(t)('nav.portal')), 1))
                : (currentPanel.value === 'table')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(t)('nav.table')), 1))
                  : (currentPanel.value === 'kitchen')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)('nav.kitchen')), 1))
                    : (currentPanel.value === 'admin')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(t)('nav.admin')), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, "Cafe"))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: "/",
              class: _normalizeClass([
            'rounded-2xl px-4 py-2 text-sm font-medium transition',
            currentPanel.value === 'portal'
              ? 'bg-cyan-400/15 text-cyan-100 ring-1 ring-cyan-300/40'
              : 'text-slate-400 hover:text-white'
          ])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('nav.portal')), 1)
              ]),
              _: 1
            }, 8, ["class"]),
            (canOpenTable.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/table",
                  class: _normalizeClass([
            'rounded-2xl px-4 py-2 text-sm font-medium transition',
            currentPanel.value === 'table'
              ? 'bg-cyan-400/15 text-cyan-100 ring-1 ring-cyan-300/40'
              : 'text-slate-400 hover:text-white'
          ])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('nav.table')), 1)
                  ]),
                  _: 1
                }, 8, ["class"]))
              : (_openBlock(), _createElementBlock("button", _hoisted_11, _toDisplayString(_unref(t)('nav.table')), 1)),
            _createVNode(_component_router_link, {
              to: "/kitchen",
              class: _normalizeClass([
            'rounded-2xl px-4 py-2 text-sm font-medium transition',
            currentPanel.value === 'kitchen'
              ? 'bg-cyan-400/15 text-cyan-100 ring-1 ring-cyan-300/40'
              : 'text-slate-400 hover:text-white'
          ])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('nav.kitchen')), 1)
              ]),
              _: 1
            }, 8, ["class"]),
            (canOpenAdmin.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: "/admin",
                  class: _normalizeClass([
            'rounded-2xl px-4 py-2 text-sm font-medium transition',
            currentPanel.value === 'admin'
              ? 'bg-cyan-400/15 text-cyan-100 ring-1 ring-cyan-300/40'
              : 'text-slate-400 hover:text-white'
          ])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('nav.admin')), 1)
                  ]),
                  _: 1
                }, 8, ["class"]))
              : (_openBlock(), _createElementBlock("button", _hoisted_12, _toDisplayString(_unref(t)('nav.admin')), 1)),
            (canOpenPortalOwner.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 4,
                  to: "/portal-owner",
                  class: "rounded-2xl px-4 py-2 text-sm font-medium text-cyan-100 ring-1 ring-cyan-300/30 transition hover:bg-cyan-400/15"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('nav.portalAdmin')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("select", {
                value: _unref(language),
                onChange: _cache[0] || (_cache[0] = ($event: any) => (_unref(setLanguage)(($event.target as HTMLSelectElement).value as any))),
                class: "rounded-2xl px-3 py-2 text-sm font-semibold uppercase tracking-[0.15em] bg-slate-800/60 text-slate-300 border border-cyan-400/20 hover:border-cyan-400/40 focus:outline-none focus:border-cyan-400/60 transition cursor-pointer"
              }, [...(_cache[1] || (_cache[1] = [
                _createStaticVNode("<option value=\"en\">EN</option><option value=\"ru\">RU</option><option value=\"uk\">UK</option><option value=\"de\">DE</option><option value=\"pl\">PL</option><option value=\"es\">ES</option>", 6)
              ]))], 40, _hoisted_14)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createTextVNode(_toDisplayString(_unref(t)('nav.orders')) + ": ", 1),
            _createElementVNode("span", _hoisted_16, _toDisplayString(orderCount.value), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})